import { render, staticRenderFns } from "./ServiceDesk.vue?vue&type=template&id=687e1d0c&scoped=true"
import script from "./ServiceDesk.vue?vue&type=script&lang=js"
export * from "./ServiceDesk.vue?vue&type=script&lang=js"
import style0 from "./ServiceDesk.vue?vue&type=style&index=0&id=687e1d0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687e1d0c",
  null
  
)

export default component.exports